
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React, { useState } from 'react';
import { ShieldCheck, Plus, Lock, ChevronRight } from 'lucide-react';
import { Card } from '../../ui/Card';
import { Button } from '../../ui/Button';
import { MainnetValidation } from './MainnetValidation';

export const QuickContract: React.FC = () => {
    const [title, setTitle] = useState('');
    const [amount, setAmount] = useState('');

    return (
        <Card noPadding className="border-stone-200 dark:border-white/10 shadow-smooth bg-white dark:bg-[#15171C] rounded-sm overflow-hidden flex flex-col">
            <div className="p-6 sm:p-8 border-b border-stone-100 dark:border-white/5 bg-gray-50/50 dark:bg-white/[0.01]">
                <div className="flex items-center gap-3 mb-2">
                    <div className="p-2 bg-nobel-gold/10 rounded-sm text-nobel-gold">
                        <ShieldCheck size={20} />
                    </div>
                    <h3 className="font-serif text-xl sm:text-2xl font-bold text-[#0A0B0F] dark:text-white uppercase tracking-tight">Create New Contract</h3>
                </div>
                <p className="text-[10px] font-black text-stone-400 uppercase tracking-widest opacity-60">Securely hold funds until terms are met</p>
            </div>

            <div className="p-6 sm:p-8 space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                        <label className="text-[10px] font-black text-stone-400 uppercase tracking-widest ml-1">Contract Name</label>
                        <div className="relative">
                            <input 
                                type="text" 
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                placeholder="e.g. Consulting Project"
                                className="w-full p-4 bg-stone-50 dark:bg-black/20 rounded-sm border border-stone-200 dark:border-white/10 text-xs font-bold uppercase tracking-wider outline-none focus:border-nobel-gold dark:text-white transition-all"
                            />
                        </div>
                    </div>
                    <div className="space-y-2">
                        <label className="text-[10px] font-black text-stone-400 uppercase tracking-widest ml-1">Amount (USDC)</label>
                        <div className="relative">
                            <input 
                                type="number" 
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                placeholder="0.00"
                                className="w-full p-4 bg-stone-50 dark:bg-black/20 rounded-sm border border-stone-200 dark:border-white/10 text-xs font-mono font-bold outline-none focus:border-nobel-gold dark:text-white transition-all"
                            />
                        </div>
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row items-center gap-4">
                    <div className="flex-1 p-4 bg-stone-50 dark:bg-black/10 rounded-sm border border-stone-100 dark:border-white/5 flex items-center gap-3">
                        <Lock size={16} className="text-stone-400" />
                        <span className="text-[10px] font-bold text-stone-500 uppercase tracking-widest">Privacy: Enabled</span>
                    </div>
                    <Button variant="secondary" size="lg" className="w-full sm:w-auto h-14 px-10 rounded-sm bg-[#0A0B0F] dark:bg-white text-white dark:text-black font-black uppercase tracking-[0.25em] text-[11px] shadow-xl group">
                        CREATE AGREEMENT <ChevronRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
                    </Button>
                </div>
            </div>

            <MainnetValidation />
        </Card>
    );
};
